import axios from 'axios'
import i18n from '../i18n'
import store from '../store'
import { extractApiErrorMessage } from './ai/extract-api-error-message'

const BASE_URL = process.env.VUE_APP_API_BASE_URL || '/web/v1'

function t(key) {
  return String(i18n.t(key))
}

function showError(message) {
  var detail = message != null ? String(message) : ''
  store.dispatch('showErrorModal', {
    title: t('common.error'),
    message: detail,
    detailMessage: detail
  })
}

function showLoginModal() {
  store.dispatch('showLoginModal')
}

const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json'
  }
})

apiClient.interceptors.request.use(
  function(config) {
    var token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  function(response) {
    /* blob 响应（如 /download）直接返回，不走业务 code 校验 */
    if (response.config && response.config.responseType === 'blob') {
      return response.data
    }
    var allowBiz = response.config && response.config.allowBizCodes
    var bizCode = response.data ? Number(response.data.code) : null
    var isAllowedBiz = false
    if (response.data && allowBiz && allowBiz.length) {
      for (var abi = 0; abi < allowBiz.length; abi++) {
        if (bizCode === Number(allowBiz[abi])) {
          isAllowedBiz = true
          break
        }
      }
    }
    if (response.data && response.data.code !== 200 && response.data.code !== 220 && !isAllowedBiz) {
      console.log('API Response Error:', response.config.url, response.data)
    }
    if (response.data && response.data.code === 502) {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      store.commit('SET_USER_INFO', null)
      showLoginModal()
      return Promise.reject(new Error(t('api.errors.sessionExpired')))
    }
    /* 仅当请求 config.allowBizCodes 包含某业务 code 时放行（如直连图生 query_state 的 220 pending） */
    if (response.data && isAllowedBiz) {
      return response.data
    }
    if (response.data && response.data.code !== 200 && response.data.code !== 502) {
      var bizMsg = extractApiErrorMessage(response.data) || t('api.errors.operationFailed')
      showError(String(bizMsg))
      return Promise.reject(new Error(String(bizMsg)))
    }
    return response.data
  },
  function(error) {
    var message = ''
    if (error.response && error.response.data) {
      message = extractApiErrorMessage(error.response.data)
    }
    if (!message && error.message) {
      message = String(error.message).trim()
    }
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
    if (!message && error.response) {
      switch (error.response.status) {
        case 400:
          message = t('api.errors.badRequest')
          break
        case 401:
          message = t('api.errors.unauthorized')
          break
        case 403:
          message = t('api.errors.forbidden')
          break
        case 404:
          message = t('api.errors.notFound')
          break
        case 500:
          message = t('api.errors.serverError')
          break
        default:
          message = t('api.errors.requestFailed')
      }
    }
    if (!message) {
      message = t('api.errors.requestFailed')
    }
    showError(message)
    return Promise.reject(new Error(message))
  }
)

export default apiClient

export function setBaseUrl(url) {
  apiClient.defaults.baseURL = url
}

export function setToken(token) {
  if (token) {
    localStorage.setItem('token', token)
  } else {
    localStorage.removeItem('token')
  }
}
